import React, { useEffect, useState } from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { get, sortBy, filter, includes, map } from "lodash";
import clsx from "clsx";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";

import { fetchPost, fetchPut } from "../../api/fetch";
import CloseIcon from "./CloseIcon";
import CustomButton from "./CustomButton";
import FormSection from "./FormSection";
import { dbFormat } from "../../utils/date";
import colors from "../../assets/style/colors";
import images from "../../assets/img/images";
import { getAttributeValue } from "../../utils/profile";
import { walkInOut } from "../../constants/reducers";

const styles = {
  dialogPaper: {
    padding: "12px",
    minWidth: "400px",
    maxWidth: "400px",
  },
  closeIconItem: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  link: {
    cursor: "pointer",
    color: colors.primary,
    "&:hover": {
      textDecoration: "underline",
    },
  },
  title: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textTransform: "uppercase",
    fontWeight: 500,
    "& img": {
      marginRight: "10px",
    },
  },
  allow: {
    color: colors.cardGreen,
  },
  deny: {
    color: colors.errorRed,
  },
  requireAssistance: {
    color: colors.selectedOrange,
  },
};

const ChangeDecisionDialog = (props) => {
  const { classes, log, refreshLog, section, hideRequireAssistanceButton = false, disableButtons = false, isLiveEventsDriveInOut = false } = props;

  const [open, setOpen] = useState(false);
  const [decision, setDecision] = useState();
  const [comment, setComment] = useState();
  const [isDefineAccess, setIsDefineAccess] = useState(false);

  useEffect(() => {
    if (isLiveEventsDriveInOut && sessionStorage.getItem("defineAccess") == get(log, ["parent", "id"])) {
      setIsDefineAccess(true)
    }
  }, [log])

  const mainEvent = get(
    sortBy(
      filter(
        get(log, ["events"]),
        (e) =>
          includes(
            section === walkInOut ? [58, 59] : isLiveEventsDriveInOut ? [60, 61, 10, 12, 69, 65, 72, 71, 2] : [60, 61],
            get(e, ["type", "id"])
          ) &&
          (section === walkInOut || (isLiveEventsDriveInOut ? [1, 2, 3, 4].includes(get(log, ["profile", "type", "id"])) : get(e, ["profile", "type", "id"]) === 2))
      ),
      (e) => -e.created_on
    ),
    [0]
  )


  const currentDecision = getAttributeValue(mainEvent, 105);

  const defineAccess = async () => {
    try {

      let newEvent = {};
      if (isLiveEventsDriveInOut) {
        newEvent = {
          "type_id": 176,
          "event_group_id": get(log, ["parent", "id"]),
          "profile_id": get(log, ["profile", "id"]),
          "attributes": []
        }
      } else {
        newEvent = {
          active: true,
          event_group_id: get(log, ["id"]),
          type_id: get(mainEvent, ["type", "id"]),
          profile_id: get(mainEvent, ["profile", "id"]),
          zone_id: get(mainEvent, ["zone", "id"]),
          attributes: [
            ...map(
              filter(
                get(mainEvent, ["attributes"]),
                (attr) => !includes([105, 19], attr.id)
              ),
              (attr) => ({
                id: attr.id,
                value:
                  attr.data_type === "datetime"
                    ? dbFormat(attr.value, "YYYY-MM-DD[T]HH:mm:ss.SS[Z]")
                    : attr.value,
              })
            ),
          ],
        };
      }
      newEvent.attributes.push({
        id: 105,
        value: decision,
      });
      if (comment) {
        newEvent.attributes.push({
          id: 19,
          value: comment,
        });
      }
      await fetchPost("events", newEvent);
      await fetchPut(`events/${get(mainEvent, ["id"])}`, { active: false });
      refreshLog(get(log, ["parent", "id"]) ? get(log, ["parent", "id"]) : get(log, ["id"]));
      setComment();
      setOpen(false);
      if (isLiveEventsDriveInOut) {
        setIsDefineAccess(true)
        sessionStorage.setItem("defineAccess", get(log, ["parent", "id"]))
      }
      if (props.closeDialog) props.closeDialog();
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <Grid item xs style={{ paddingRight: "100px", ...props.style }}>
        <Grid container justify="flex-end" alignItems="center">
          {currentDecision !== 44 && (
            <Grid item style={{ margin: "0px 10px" }}>
              <CustomButton
                variant="contained"
                style={{
                  backgroundColor: colors.errorRed,
                  color: colors.white,
                  minWidth: "100px",
                }}
                startIcon={<img src={images.deniedWhite} alt="deny" />}
                onClick={() => {
                  setDecision(44);
                  setOpen(true);
                }}
                disabled={disableButtons || isDefineAccess}
              >
                {I18n.get("site_deny")}
              </CustomButton>
            </Grid>
          )}
          {(currentDecision !== 93 && !hideRequireAssistanceButton) && (
            <Grid item style={{ margin: "0px 10px" }}>
              <CustomButton
                variant="contained"
                style={{
                  backgroundColor: colors.selectedOrange,
                  color: colors.white,
                  minWidth: "100px",
                }}
                startIcon={
                  <img
                    src={images.requireAssistanceWhite}
                    alt="require_assistance"
                  />
                }
                onClick={() => {
                  setDecision(93);
                  setOpen(true);
                }}
                disabled={disableButtons || isDefineAccess}
              >
                {I18n.get("dashboard_requireAssistance")}
              </CustomButton>
            </Grid>
          )}
          {currentDecision !== 43 && (
            <Grid item style={{ margin: "0px 10px" }}>
              <CustomButton
                variant="contained"
                style={{
                  backgroundColor: colors.cardGreen,
                  color: colors.white,
                  minWidth: "85px",
                }}
                startIcon={<img src={images.allowedWhite} alt="allowed" />}
                onClick={() => {
                  setDecision(43);
                  setOpen(true);
                }}
                disabled={disableButtons || isDefineAccess}
              >
                {I18n.get("site_allow")}
              </CustomButton>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Dialog open={open} classes={{ paper: classes.dialogPaper }}>
        <Grid container direction="column">
          <Grid item>
            <Grid container alignItems="center">
              <Grid item xs={2} />
              <Grid
                item
                xs
                className={clsx(classes.title, {
                  [classes.allow]: decision === 43,
                  [classes.deny]: decision === 44,
                  [classes.requireAssistance]: decision === 93,
                })}
              >
                <img
                  src={
                    decision === 43
                      ? images.greenCheckmarkWhite
                      : decision === 44
                        ? images.deniedIcon
                        : images.requireAssistanceOrange
                  }
                  alt="icon"
                />
                {decision === 43
                  ? I18n.get("site_allowAccess")
                  : decision === 44
                    ? I18n.get("site_denyAccess")
                    : I18n.get("dashboard_requireAssistance")}
              </Grid>
              <Grid item xs={2} className={classes.closeIconItem}>
                <CloseIcon closeFunction={() => setOpen(false)} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item style={{ padding: "12px" }}>
            <Grid item>
              <FormSection
                formValue={[comment || ""]}
                setFormValue={(name, index, value) => setComment(value)}
                title={"comments"}
                id={"comment"}
                type="input"
                options={{
                  multiline: true,
                  rows: 5,
                }}
              />
            </Grid>
            <Grid item>
              <Grid container justify="center" style={{ marginTop: "40px" }}>
                <Grid item>
                  <CustomButton color="primary" onClick={() => setOpen(false)}>
                    {I18n.get("site_cancel")}
                  </CustomButton>
                </Grid>
                <Grid item style={{ marginLeft: "10px" }}>
                  <CustomButton
                    variant="contained"
                    color="primary"
                    onClick={defineAccess}
                  >
                    {I18n.get("site_confirm")}
                  </CustomButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default withStyles(styles)(ChangeDecisionDialog);
